// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "#sheets-preview .list-wrapper{flex-grow:1;overflow-y:auto}#sheets-preview .title-block{margin-bottom:1em}", ""]);
// Exports
module.exports = exports;
